import React__default, { useState, useEffect, useContext } from 'react';
import Styles from './OtpForm.module.scss.js';
import { AppContext } from '../../../app-context.js';
import FlatInput from '../../flat-input/FlatInput.js';
import OtpInput from '../../otp-input/OtpInput.js';
import { phoneNumModel } from '../phone-num-form/phoneNumModel.js';
import AppCheckbox from '../../app-checkbox/AppCheckbox.js';
import { ReactComponent as SvgWhatsappGreen } from '../../../icons/WhatsappGreen.svg.js';
import { ReactComponent as SvgNfEditIconBlue } from '../../../icons/nf_editIconBlue.svg.js';
import { otpModel } from './otpModel.js';
import classNames from 'classnames';

const OtpForm = ({ onBlurPhoneNumField, onClickResendOtp, onChangeOtp, formikConfig, isValid, onClickEditNumber, className, watsAppCheckboxClassname }) => {
    const [otp, setOtp] = useState("");
    useEffect(() => {
        // (async () => {
        //     const otpData = await getOtpValue();
        //     console.log(otpData, "otpData");
        // })();
        /**
         * Read OTP from sms POC - Gowdham
         */
        // if ("OTPCredential" in window) {
        //     // const ac = new AbortController();
        //     navigator.credentials
        //         .get({
        //             otp: { transport: ["sms"] }
        //         })
        //         .then((otp: any) => {
        //             console.log(otp, "------->");
        //             setOtp(otp.code);
        //         })
        //         .catch((err) => {
        //             console.log(err);
        //         });
        // }
    }, []);
    const { isMobile } = useContext(AppContext);
    const _onChangeOtp = (e) => {
        formikConfig.handleChange(otpModel.fields.otp)(e);
        onChangeOtp === null || onChangeOtp === void 0 ? void 0 : onChangeOtp(e);
    };
    const onChangeWACheckbox = (isChecked) => {
        formikConfig.setFieldValue(phoneNumModel.fields.whatsappUpdatesEnabled, isChecked);
    };
    useEffect(() => {
        formikConfig.setFieldError(otpModel.fields.otp, "Required!");
    }, []);
    return (React__default.createElement("div", { className: classNames(Styles.main, className) },
        React__default.createElement("div", { className: Styles.mobileBox },
            React__default.createElement("div", { onClick: onClickEditNumber, style: { cursor: "pointer" } },
                React__default.createElement(FlatInput, { name: phoneNumModel.fields.phoneNum, type: "number", isRequired: true, labelText: "Enter your mobile number", valuePrefix: "+91 -", value: String(formikConfig.values.phoneNum || ""), onChange: formikConfig.handleChange(phoneNumModel.fields.phoneNum), onBlur: onBlurPhoneNumField, error: formikConfig.errors.phoneNum, isValid: isValid, containerStyles: {}, disabled: true, showValidationErrOnChange: false }),
                React__default.createElement("span", { className: Styles.phoneEdit },
                    " ",
                    React__default.createElement(SvgNfEditIconBlue, null))),
            React__default.createElement("div", { className: classNames(Styles.whatsAppCheckbox, watsAppCheckboxClassname) },
                React__default.createElement(AppCheckbox, { labelText: "Get updates on", isChecked: !!formikConfig.values.whatsappUpdatesEnabled, onChange: onChangeWACheckbox, styles: {
                        fontWeight: "bolder",
                        width: "200px",
                        fontSize: "14px",
                        color: "#0D132D"
                    }, labelClass: Styles.label, checkboxStyle: { width: "18px", height: "18px" } }),
                React__default.createElement("span", { className: Styles.whatsApp },
                    React__default.createElement(SvgWhatsappGreen, null),
                    "WhatsApp"))),
        React__default.createElement("div", { className: Styles.otpBox },
            React__default.createElement("div", { className: Styles.otpText },
                React__default.createElement("p", null,
                    "Please enter the OTP sent to your mobile number",
                    React__default.createElement("strong", null,
                        "+91-",
                        formikConfig.values.phoneNum))),
            React__default.createElement(OtpInput, { onChange: _onChangeOtp, value: formikConfig.values.otp ? String(formikConfig.values.otp) : otp, error: formikConfig.errors.otp, onClickResendOtp: onClickResendOtp, wraperClass: Styles.otpWraper, resendbtnClass: Styles.resendOtpBtn, errorStyle: { top: isMobile ? "-5px" : "-11px", left: "0px" } }))));
};

export { OtpForm as default };
//# sourceMappingURL=OtpForm.js.map
